import type { ReactNode, ForwardedRef } from 'react';

import { forwardRef } from 'react';

import useClassy from '@core/hooks/useClassy';

import classes from './index.module.scss';

interface PlanUpgradeContainerProps {
  children: ReactNode;
  className?: string;
  gradient?: boolean;
  kind?: 'disabled' | 'paygate';
}

/**
 * Used as the container for our trial and paygate UI components.
 */
function PlanUpgradeContainer(
  { children, className, gradient = false, kind = 'paygate' }: PlanUpgradeContainerProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const bem = useClassy(classes, 'PlanUpgradeContainer');

  return (
    <div ref={ref} className={bem('&', gradient ? '_gradient' : '', kind && `_${kind}`, className)}>
      {children}
    </div>
  );
}

export default forwardRef(PlanUpgradeContainer);
